import { ProgramType } from "~/graphql/supergraphEnums";

export const NONE = "None";

/** The unassigned initial value ("") and the None option both mean "no program". */
export const isNoProgram = (program: string) => !program || program === NONE;

/**
 * The settings-dropdown option set (HLD §7.4/§7.9). Payments (CRB) is excluded — it is
 * not assignable here — and Legacy KYC is investor-slot display only.
 */
export const PROGRAM_OPTIONS: { label: string; programType: ProgramType }[] = [
  { label: NONE, programType: ProgramType.None },
  { label: "Screening", programType: ProgramType.Screening },
  { label: "KYC", programType: ProgramType.KycOnly },
  { label: "AML (US)", programType: ProgramType.UsAml },
  { label: "AML (Caymans)", programType: ProgramType.CaymansAml },
  { label: "AML (Luxembourg)", programType: ProgramType.LuxembourgAml },
];

/** Slices return the display name; a raw ProgramType or the grid's "--" also resolve. */
export const resolveProgramLabel = (assigned: string | null | undefined) =>
  PROGRAM_OPTIONS.find((option) => option.label === assigned || option.programType === assigned)
    ?.label ?? "";
